import { css, cx } from 'linaria';
import { FavoriteIcon } from 'components/icons/FavoriteIcon';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
const favoriteWrapper = "f166jgra";
export function FavoriteTag({
  margin
}) {
  const className = cx(favoriteWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <FavoriteIcon />
    </div>;
}

require("./tag-favorite.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-favorite.js");